export default __webpack_public_path__ + "static/media/2.0df1cf7d.jpg";